import React from 'react';

export default function DocumentSearchHeader() {
  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Pencarian Dokumen</h1>
      <p className="text-gray-500 mt-1">Cari dokumen debitur berdasarkan berbagai kriteria</p>
    </div>
  );
}
